let apiMode = apiModeType; //接口环境
let apiUrl = ""; //主接口
let imgUrl='';
let jsonUrl= ""; //json文件路径
let resourceUrl = "";//资源路径
let deviceType = 3; //设备环境 0浏览器环境 1支付宝环境 2微信环境 3APP
let orderSource = 14; //订单来源 4浏览器 6支付宝生活号 9微信生活号 12京东 14支付宝小程序 16安卓设备 17苹果设备
let mySelfURL = location.origin;
let isIOS = false;

switch (apiMode) {
  case "dev": //开发环境
    apiUrl = "http://192.168.0.252:1007/";
    jsonUrl = "https://resource.dafang24.com/Dev/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
  case "test": // 201测试环境
    apiUrl = "http://192.168.0.201:5028/";
    jsonUrl = "https://resource.dafang24.com/Test/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
  case "sit" :
    apiUrl="http://rentapi.sit.dafang24.com/";
    jsonUrl = "https://resource.dafang24.com/Test/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
  case "build": //发布环境
    apiUrl = "https://api.new.dafang24.com:442/";
    jsonUrl = "https://resource.dafang24.com/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
}
imgUrl = resourceUrl;
import router from '@/router';
if( router.mode != 'history' ){
  mySelfURL = mySelfURL + '/#'
}

//判断设备环境
let userAgent = navigator.userAgent;
if (/DFZCAPPAndroid/.test(userAgent) ) { //安卓设备
  orderSource = 16;
  isIOS = false;
}
if (/DFZCFlutterAPPAndroid/.test(userAgent) ) { //安卓设备
  orderSource = 16;
  isIOS = false;
}
// if (!!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) { //苹果设备
//   orderSource = 17;
//   isIOS = true;
// }
if ( /DFZCAPPiOS/.test(userAgent) ) { //苹果设备
  orderSource = 17;
  isIOS = true;
}
export {
  apiMode,
  apiUrl,
  jsonUrl,
  resourceUrl,
  deviceType,
  orderSource,
  mySelfURL,
  isIOS,
  imgUrl
}

